import { render, staticRenderFns } from "./LayerBottom.vue?vue&type=template&id=37896a3b&scoped=true&"
import script from "./LayerBottom.vue?vue&type=script&lang=js&"
export * from "./LayerBottom.vue?vue&type=script&lang=js&"
import style0 from "./LayerBottom.vue?vue&type=style&index=0&id=37896a3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37896a3b",
  null
  
)

export default component.exports